import React, { createContext, useContext, useEffect } from 'react'
import { PropertiesPanelStore } from './PropertiesPanelStore'
import { useFurnitureStore } from '@fabrick/components'

const PropertiesPanelStoreContext = createContext<PropertiesPanelStore | null>(null)

export interface PropertiesPanelStoreProviderProps {
  children: React.ReactNode
}

export const PropertiesPanelStoreProvider: React.FC<PropertiesPanelStoreProviderProps> = ({ children }) => {
  const furnitureStore = useFurnitureStore()
  const [store] = React.useState(() => new PropertiesPanelStore())

  useEffect(() => {
    store.setFurnitureStore(furnitureStore)
  }, [store, furnitureStore])

  return (
    <PropertiesPanelStoreContext.Provider value={store}>
      {children}
    </PropertiesPanelStoreContext.Provider>
  )
}

export const usePropertiesPanelStore = () => {
  const store = useContext(PropertiesPanelStoreContext)
  if (!store) {
    throw new Error('usePropertiesPanelStore must be used within PropertiesPanelStoreProvider')
  }
  return store
}
